export enum EnumSettingsTrackingEvent {
  SPONSORSHIP_COPY_VOUCHER_CODE = '[Sponsorship] Copy Voucher Code',
}
